import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ETenantActions,
  GetTenant,
  GetTenantBaseUrl,
  GetTenantFailure,
  GetTenantSuccess
} from '../actions/tenant.actions';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { TenantService } from '@eview/core/tenant/tenant.service';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class TenantEffects {
  constructor(private tenantService: TenantService) {}

  private readonly actions$ = inject(Actions);

  getBaseUrl$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetTenantBaseUrl>(ETenantActions.GetTenanatBaseUrl),
      map(action => action.payload),
      switchMap(payload =>
        this.tenantService.getBaseUrl(payload).pipe(
          map(result => new GetTenantSuccess(result)),
          catchError(() => of(new GetTenantFailure()))
        )
      )
    )
  );

  get$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetTenant>(ETenantActions.GetTenant),
      switchMap(() =>
        this.tenantService.get().pipe(
          map(payload => new GetTenantSuccess(payload)),
          catchError(() => of(new GetTenantFailure()))
        )
      )
    )
  );
}
